import { createReducer } from '@topconagriculture/frontend-utils';

import { getInventoryRequirements } from './inventory.actions';
import { InventoryReportData } from './inventory.type';

export type InventoryState = InventoryReportData;

const initialState: InventoryState = {
  reportData: { lastDelivery: '', gridData: { items: [], summaryItems: [] } },
  userSettings: {
    currencyString: '€',
    dateFormat: 'dd-mm-yyyy',
    decimalSeparator: ',',
    thousandSeparator: '.',
    weightUnit: 'kg',
  },
};

const inventoryReducer = createReducer(initialState, {
  [getInventoryRequirements.done.type]: (state: InventoryState, action) => action.payload.result,
});

export default inventoryReducer;
